import { canonicalPhone } from "./clientIdempotency.mjs";

function timestampValue(value) {
  if (value == null || value === "") return 0;
  const numeric = Number(value);
  if (Number.isFinite(numeric)) return numeric < 1e12 ? numeric * 1000 : numeric;
  const parsed = Date.parse(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

function canonicalKeyPriority(lead, storeId, phone) {
  const rawKey = String(lead?._rawPhone || "");
  if (rawKey === `${storeId}_${phone}`) return 3;
  if (rawKey === phone) return 2;
  return 1;
}

function preferredLead(current, candidate, storeId, phone) {
  const currentPriority = canonicalKeyPriority(current, storeId, phone);
  const candidatePriority = canonicalKeyPriority(candidate, storeId, phone);
  if (candidatePriority !== currentPriority) {
    return candidatePriority > currentPriority ? candidate : current;
  }
  const currentUpdated = timestampValue(current?.ultima_atualizacao || current?.updatedAt || current?.data_criacao || current?.createdAt);
  const candidateUpdated = timestampValue(candidate?.ultima_atualizacao || candidate?.updatedAt || candidate?.data_criacao || candidate?.createdAt);
  return candidateUpdated > currentUpdated ? candidate : current;
}

export function dedupeLeadsForDisplay(leads) {
  const byIdentity = new Map();
  const withoutIdentity = [];

  for (const lead of leads || []) {
    const storeId = Number(lead?.lojaAtual ?? lead?.storeId);
    const phone = canonicalPhone(lead?.telefone || lead?.phone);
    if (!Number.isFinite(storeId) || !phone) {
      withoutIdentity.push(lead);
      continue;
    }
    const identity = `${storeId}:${phone}`;
    const current = byIdentity.get(identity);
    byIdentity.set(identity, current ? preferredLead(current, lead, storeId, phone) : lead);
  }

  return [...byIdentity.values(), ...withoutIdentity];
}